export const ERROR_FETCHING = 'footballPlayers/ERROR_FETCHING';
export const SET_PLAYERS = 'footballPlayers/SET_PLAYERS';


// WEBPACK FOOTER //
// ./src/footballPlayers/actionTypes/players.js